module.exports = __webpack_public_path__ + "img/info (1).3aea435e.svg";